<template>
  <div class="regfest-service-menu-container">
    <div
      class="regfest-service-menu__overlay"
      :class="{'regfest-service-menu__overlay--active': openMenu}"
      @click="_closeMenu"
    />
    <div
      ref="menu"
      class="regfest-service-menu"
      :class="{'regfest-service-menu--mobile-active': openMenu}"
    >
      <div class="regfest-service-menu__container">
        <div class="regfest-service-menu__header">Услуги</div>
        <div class="regfest-service-menu__list">
          <router-link
            v-for="item in menuList"
            :key = item.id
            @click.native="_onMenuItemClick(item.id)"
            :to="{ name: 'participantTable', params: {serviceId: item.id}}"
            class="regfest-service-menu__list-item"
            tag="div"
          >
            {{ item.attributes.title }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftMenu',
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
    openMenu: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    _closeMenu() {
      this.$emit('close-menu')
    },

    _onMenuItemClick(id) {
      this.$emit('menu-item-click', id)
    }
  }
};
</script>

<style lang="scss">
@import "src/app/styles/variables";
.regfest-service-menu {
  max-width: 300px;
  width: 300px;
  background: #f5f7fa;
  transition: all 0.3s ease-in-out;
  height: 100%;
  z-index: 20;

  .router-link-exact-active,
  .router-link-active{
    color: #2f80ed;
  }

  @media (max-width: $mq-tablet) {
    position: absolute;
    left: -100%;
  }

  @media (max-width: $mq-mobile) {
    width: 100%;
  }

  &--mobile-active {
    left: 0;
  }

  &__overlay {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 18;
    background: gray;
    opacity: 0.3;
    width: 100%;
    height: 100%;

    &--active {
      display: block;
    }
  }

  &__container {
    padding: 20px;
  }

  &__header {
    font-size: 24px;
    color: #000;
    text-align: left;
  }

  &__list {

  }

  &__list-item {
    font-size: 14px;
    color: #000;
    cursor: pointer;

    &:hover {
      color: #2f80ed;
    }

    @media (max-width: $mq-mobile) {
      font-size: 16px;
    }
  }
}
</style>
